import { useMemo, useState } from "react";
import { useInsideModal } from "src/modals";
import InternalModal from "src/modals/configs/InternalModal";
import EditCoverGallery from "./components/EditCoverGallery";
import EditCoverGalleryContext, {
	EditCoverGalleryContextType,
} from "./contexts/EditCoverGalleryContext";
import { useEditCoverGalleryModalDimensions } from "./EditCoverGalleryModalSkeleton";
import { createEditCoverGalleryStore } from "./stores/editCoverGalleryStore";

const EditCoverGalleryModal = () => {
	const { props, closeSelf } = useInsideModal<InternalModal["EditCoverGallery"]>();
	const [store] = useState(() =>
		createEditCoverGalleryStore({
			...props,
			onClose: closeSelf,
		}),
	);
	const value = useMemo<EditCoverGalleryContextType>(
		() => ({
			store,
		}),
		[store],
	);
	const style = useEditCoverGalleryModalDimensions();
	return (
		<EditCoverGalleryContext.Provider value={value}>
			<EditCoverGallery style={style} />
		</EditCoverGalleryContext.Provider>
	);
};
export default EditCoverGalleryModal;
